import { Box, Drawer } from '@mui/material';
import { useRoentgenStore } from './roentgenStore';
import { RoentgenPanel } from './RoentgenPanel';
import { useResizableSplitter } from '../../hooks/useResizableSplitter';

const DEFAULT_DRAWER_WIDTH = 380;
const MIN_DRAWER_WIDTH = 250;
const MAX_DRAWER_WIDTH = 800;

export const RoentgenDrawer = () => {
  const open = useRoentgenStore((s) => s.drawerOpen);
  const { size, splitterProps } = useResizableSplitter({
    direction: 'horizontal',
    initialSize: DEFAULT_DRAWER_WIDTH,
    minSize: MIN_DRAWER_WIDTH,
    maxSize: MAX_DRAWER_WIDTH,
    invertDelta: true,
  });

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={open}
      sx={{
        width: open ? size : 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: size,
          boxSizing: 'border-box',
          borderLeft: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        },
      }}
    >
      <Box sx={{ display: 'flex', height: '100%', width: '100%' }}>
        <Box
          {...splitterProps}
          sx={{
            width: 5,
            flexShrink: 0,
            cursor: 'col-resize',
            backgroundColor: 'divider',
            '&:hover': {
              backgroundColor: 'primary.light',
            },
          }}
        />
        <Box sx={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
          <RoentgenPanel />
        </Box>
      </Box>
    </Drawer>
  );
};
